(function() {
  'use strict';

  angular.module('app.sidebar')
    .factory('LegendFactory', LegendFactory);

  function LegendFactory(esriRegistry, esriLoader, $q) {
    // let legends = [];

    let LegendFactoryService = {
      getLegend: getLegend
    };

    return LegendFactoryService;

    //////////// functions

    function getLegend(url) {
      let d = $q.defer();
      esriLoader.require([
        'esri/request'
      ], function(
        esriRequest
      ) {
        // with esri request
        let requestHandle = esriRequest({
          'url': url + '/legend',
          'content': {
            'f': 'json'
          },
          'handleAs': 'json',
          'callbackParamName': 'callback',

        });
        requestHandle.then(function(results) {
          d.resolve(results.layers);
        }, function(err) {
          console.error(err);
        });
      });
      return d.promise;
    }
  }
}());
